module.exports = __webpack_public_path__ + "static/scale-model-of-w&od-trailhead-in-washington-d.c.-93467b0c03041e0a60719bd915c86314.png";